import { styled } from '../theme';
import Text from './Text';

const P = styled(Text.withComponent('p'))(({ theme }) => ({}));

export default P;
